/**
 * @generated SignedSource<<33438d1b35bb57202c5c52f4a77ab7d4>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type calendarCardAssignee_calendar$data = {
  readonly assigneeField: {
    readonly user: {
      readonly name: string;
      readonly picture: AGG$URL;
    } | null | undefined;
  } | null | undefined;
  readonly " $fragmentType": "calendarCardAssignee_calendar";
};
export type calendarCardAssignee_calendar$key = {
  readonly " $data"?: calendarCardAssignee_calendar$data;
  readonly " $fragmentSpreads": FragmentRefs<"calendarCardAssignee_calendar">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "calendarCardAssignee_calendar",
  "selections": [
    {
      "concreteType": "JiraSingleSelectUserPickerField",
      "kind": "LinkedField",
      "name": "assigneeField",
      "plural": false,
      "selections": [
        {
          "kind": "LinkedField",
          "name": "user",
          "plural": false,
          "selections": [
            {
              "kind": "ScalarField",
              "name": "name"
            },
            {
              "kind": "ScalarField",
              "name": "picture"
            }
          ]
        }
      ]
    }
  ],
  "type": "JiraIssue"
};

(node as any).hash = "9c39b7138e7c0f91d00bd2f14f151774";

export default node;
